import classNames from "classnames";
import classes from "./CMSColumnContainer.module.less";
import type { CMSColumnsContainerDTO } from "~/CMSComponents/dto";
import { renderCMSComponent } from "~/CMSComponents/componentFactory";

interface Props extends Omit<CMSColumnsContainerDTO, "type"> {
  className?: string;
}

const JUSTIFY_VALUES = {
  LEFT: "flex-start",
  CENTER: "center",
  RIGHT: "flex-end",
};

export const CMSColumnContainer = (props: Props) => {
  return (
    <div
      className={classNames(classes.container, props.className)}
      style={{ justifyContent: JUSTIFY_VALUES[props.alignment] }}
      id={props.htmlId}
    >
      {props.columns.map((column, index) => {
        return renderCMSComponent(column, undefined, index);
      })}
    </div>
  );
};
